import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import api from "api";
import {injectIntl} from "react-intl";

class SurveyCollectorsSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      collectors: [],
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const {id} = this.props.survey;

    this.setState({
      loading: true,
    });

    api.survey.get.collectors({id})
      .then(collectors => {
        this.setState({
          loading: false,
          collectors,
        });
      })
      .catch(res => {
        this.setState({
          loading: false,
        });
      })
  }

  onChange(option){
    let collector = this.state.collectors.find(c => c.id === option.value);

    this.props.onChange(collector);
  }

  render() {
    const {collectors} = this.state;
    const {onlyTypes} = this.props;

    let options = _.map(collectors, collector => {
      if(onlyTypes.length > 0 && onlyTypes.indexOf(collector.type) < 0){
        return;
      }

      return {
        label: collector.name || this.props.intl.formatMessage({ id: "_.surveyCollector." + collector.type + '.name' }) + ' ' + collector.position,
        value: collector.id,
      };
    }).filter(val => val);

    return (
      <Select
        isLoading={this.props.isLoading || this.state.loading}
        isDisabled={this.props.isDisabled}
        placeholder={this.props.placeholder}
        options={options}
        onChange={this.onChange}
      />
    );
  }
}

SurveyCollectorsSelect.defaultProps = {
  isLoading: false,
  isDisabled: false,
  onlyTypes: [],
  placeholder: 'Wybierz kolektor'
};

SurveyCollectorsSelect.propTypes = {
  placeholder: PropTypes.string,
  survey: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onlyTypes: PropTypes.array,
};

export default injectIntl(SurveyCollectorsSelect);